import React, { useEffect, useState } from "react";
import axios from "axios";
import {useOutletContext } from "react-router-dom";

function NewsletterMonthly() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [monthlyBusinessDataPreviousYear, setMonthlyBusinessDataPreviousYear] = useState([]);
  const [monthlyBusinessData, setMonthlyBusinessData] = useState([]);
  const [monthlyBusinessSnapshot, setMonthlyBusinessSnapshot] = useState([]);
  const [monthlyBusinessBreakup, setMonthlyBusinessBreakup] = useState([]);
  const { setGlobalLoading, token } = useOutletContext();
  const [monthlyPreviousYTDRevenue, setMonthlyPreviousYTDRevenue] = useState(0);
  const today = new Date();
  const currentFY =
      today.getMonth() + 1 >= 4
        ? `${today.getFullYear()}-${today.getFullYear() + 1}`
        : `${today.getFullYear() - 1}-${today.getFullYear()}`;
  const [selectedYear, setSelectedYear] = useState(currentFY);
  // Previous calendar month
  const previousMonth = today.getMonth() === 0 ? 12 : today.getMonth();
  const [selectedMonth, setSelectedMonth] = useState(previousMonth);
  const months = [ { label: "January", value: 1 }, { label: "February", value: 2 }, { label: "March", value: 3 }, { label: "April", value: 4 }, { label: "May", value: 5 }, { label: "June", value: 6 }, { label: "July", value: 7 }, { label: "August", value: 8 }, { label: "September", value: 9 }, { label: "October", value: 10 }, { label: "November", value: 11 }, { label: "December", value: 12 }, ];
  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);

    try {
      const response = await axios.get(
        `${API_BASE_URL}/newsletter/get_newsletter_monthly`,
        {
          params: { year: selectedYear, month: selectedMonth },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      console.log("received data", response.data);
      
      setMonthlyBusinessDataPreviousYear(response.data.monthlyBusinessDataPreviousYear || []);
      setMonthlyBusinessData(response.data.monthlyBusinessData || []);
      setMonthlyBusinessSnapshot(response.data.monthlyBusinessSnapshot || []);
      setMonthlyBusinessBreakup(response.data.monthlyBusinessBreakup || []);
      setMonthlyPreviousYTDRevenue(Number(response.data.previousYTDRevenue || 0));
    } catch (error) {
      console.error("API Error:", error);
    } finally {
      setGlobalLoading(false);
    }
  }

  useEffect(() => {
    if (token && selectedYear) {
      fetchOptions();
    }
  }, [token, selectedYear, selectedMonth]); 

  const financialYears = Array.from({ length: 4 }, (_, i) => {
  const start = new Date().getFullYear() - i;
  const end = start + 1;
    return {
      label: `${start}-${end}`,
      value: `${start}-${end}`,
    };
  });  

  const snapshot = monthlyBusinessSnapshot[0] || {};
  const partnerData = monthlyBusinessBreakup.filter((row) => row.data_type === "PARTNER");
  const operatingPartnerData = monthlyBusinessBreakup.filter((row) => row.data_type === "OPERATING_PARTNER");
  const sectorData = monthlyBusinessBreakup.filter((row) => row.data_type === "SECTOR");
  const regionData = monthlyBusinessBreakup.filter((row) => row.data_type === "REGION");

const monthColumns = [
  "apr",
  "may",
  "jun",
  "jul",
  "aug",
  "sep",
  "oct",
  "nov",
  "dec",
  "jan",
  "feb",
  "mar"
];

const getBusinessRow = (data, type) => {
  return data.find((item) => item.data_type === type) || {};
};

const getQuarterValue = (row, quarter) => {
  const quarterMonths = {
    Q1: ["apr", "may", "jun"],
    Q2: ["jul", "aug", "sep"],
    Q3: ["oct", "nov", "dec"],
    Q4: ["jan", "feb", "mar"]
  };

  return quarterMonths[quarter].reduce(
    (total, month) => total + Number(row[month] || 0),
    0
  );
};

const calculateTotal = (row) => {
  return monthColumns.reduce(
    (total, month) => total + Number(row[month] || 0),
    0
  );
};
const currentNetAddRow = getBusinessRow(monthlyBusinessData, "NET_ADD");
const currentRevenueRow = getBusinessRow(monthlyBusinessData, "REVENUE");
const previousNetAddRow = getBusinessRow(monthlyBusinessDataPreviousYear, "NET_ADD");
const previousRevenueRow = getBusinessRow(monthlyBusinessDataPreviousYear, "REVENUE");

const getShortFY = (fy) => {
  const [start, end] = fy.split("-");

  return `${start}-${end.slice(-2)}`;
};

const currentFYLabel = getShortFY(selectedYear);
const [startYear] = selectedYear.split("-").map(Number);
const previousFYLabel = `${startYear - 1}-${String(startYear).slice(-2)}`;

// ===============================
// YTD Revenue & Net Add
// ===============================

const fiscalMonthOrder = {
  4: "apr",
  5: "may",
  6: "jun",
  7: "jul",
  8: "aug",
  9: "sep",
  10: "oct",
  11: "nov",
  12: "dec",
  1: "jan",
  2: "feb",
  3: "mar",
};

const getYTDValue = (row) => {
  const selectedMonthKey = fiscalMonthOrder[selectedMonth];
  if (!selectedMonthKey) return 0;
  const selectedIndex = monthColumns.indexOf(selectedMonthKey);
  return monthColumns
    .slice(0, selectedIndex + 1)
    .reduce(
      (total, month) => total + Number(row?.[month] || 0),
      0
    );
};

const currentYTDRevenue = calculateTotal(currentRevenueRow);
const previousYTDRevenue = Number(monthlyPreviousYTDRevenue || 0);
const currentYTDNetAdd = calculateTotal(currentNetAddRow);
const previousYTDNetAdd = getYTDValue(previousNetAddRow);

const calculateGrowth = (current, previous) => {
  if (!previous || previous === 0) return 0;
  return ((current - previous) / previous) * 100;
};
const revenueGrowth = calculateGrowth(currentYTDRevenue, previousYTDRevenue);
const netAddGrowth = calculateGrowth(currentYTDNetAdd, previousYTDNetAdd);
    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 500px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 180px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 180px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 280px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          }    
        `}
        </style>  
        <div className="card shadow-sm">
            <div className="card-body justify-content-between">
                <div className="d-flex justify-content-between align-items-center mb-2 border-bottom pb-2">

  <h4 className="mb-0">
    Newsletter Report
  </h4>

  <div className="d-flex align-items-center gap-2">

    {/* Financial Year */}
    <div style={{ width: "150px" }}>
      <select
        className="form-select"
        value={selectedYear}
        onChange={(e) => setSelectedYear(e.target.value)}
      >
        {financialYears.map((fy) => (
          <option key={fy.value} value={fy.value}>
            {fy.label}
          </option>
        ))}
      </select>
    </div>

    {/* Month */}
    <div style={{ width: "140px" }}>
      <select
        className="form-select"
        value={selectedMonth}
        onChange={(e) =>
          setSelectedMonth(Number(e.target.value))
        }
      >
        {months.map((month) => (
          <option
            key={month.value}
            value={month.value}
          >
            {month.label}
          </option>
        ))}
      </select>
    </div>

  </div>

</div>
                <div className="row">
                  {/* ======== FIRMWIDE BUSINESS =========== */}
                  {/* <div className="col-md-12 mb-4">
                    <div className="card-title mt-3">Firmwide Business Performance</div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap">
                        <thead className="table-dark">
                          <tr>
                            <th></th>
                            <th>{selectedYear}</th>
                            <th>Previous Year</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Net Add</td>
                            <td>{formatNumber(currentNetAdd)}</td>
                            <td>{formatNumber(previousNetAdd)}</td>
                          </tr>
                          <tr>
                            <td>Revenue</td>
                            <td>{formatNumber(currentRevenue)}</td>
                            <td>{formatNumber(previousRevenue)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div> */}

{/* ======== FIRMWIDE BUSINESS PERFORMANCE ======== */}

<div className="col-md-12 mb-4">

  <div className="card-title mt-3">
    Firmwide Business Performance
  </div>

  <div className="table-responsive">

    <table className="table table-bordered text-nowrap">

      <thead className="table-dark">
        <tr>
          <th></th>

          <th>Apr</th>
          <th>May</th>
          <th>Jun</th>
          <th>Q1</th>

          <th>Jul</th>
          <th>Aug</th>
          <th>Sep</th>
          <th>Q2</th>

          <th>Oct</th>
          <th>Nov</th>
          <th>Dec</th>
          <th>Q3</th>

          <th>Jan</th>
          <th>Feb</th>
          <th>Mar</th>
          <th>Q4</th>

          <th>Total</th>
        </tr>
      </thead>

      <tbody>

        {/* =========================================
            NET ADD - CURRENT YEAR
        ========================================= */}

        <tr>

          <td>
            <strong>
              Net Add {currentFYLabel}
            </strong>
          </td>

          <td>{formatNumber(currentNetAddRow.apr)}</td>
          <td>{formatNumber(currentNetAddRow.may)}</td>
          <td>{formatNumber(currentNetAddRow.jun)}</td>
          <td>{formatNumber(getQuarterValue(currentNetAddRow, "Q1"))}</td>

          <td>{formatNumber(currentNetAddRow.jul)}</td>
          <td>{formatNumber(currentNetAddRow.aug)}</td>
          <td>{formatNumber(currentNetAddRow.sep)}</td>
          <td>{formatNumber(getQuarterValue(currentNetAddRow, "Q2"))}</td>

          <td>{formatNumber(currentNetAddRow.oct)}</td>
          <td>{formatNumber(currentNetAddRow.nov)}</td>
          <td>{formatNumber(currentNetAddRow.dec)}</td>
          <td>{formatNumber(getQuarterValue(currentNetAddRow, "Q3"))}</td>

          <td>{formatNumber(currentNetAddRow.jan)}</td>
          <td>{formatNumber(currentNetAddRow.feb)}</td>
          <td>{formatNumber(currentNetAddRow.mar)}</td>
          <td>{formatNumber(getQuarterValue(currentNetAddRow, "Q4"))}</td>

          <td>{formatNumber(calculateTotal(currentNetAddRow))}</td>

        </tr>


        {/* =========================================
            REVENUE - CURRENT YEAR
        ========================================= */}

        <tr>

          <td>
            <strong>
              Revenue {currentFYLabel}
            </strong>
          </td>

          <td>
            {formatNumber(currentRevenueRow.apr)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.may)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.jun)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(currentRevenueRow, "Q1")
            )}
          </td>

          <td>
            {formatNumber(currentRevenueRow.jul)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.aug)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.sep)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(currentRevenueRow, "Q2")
            )}
          </td>

          <td>
            {formatNumber(currentRevenueRow.oct)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.nov)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.dec)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(currentRevenueRow, "Q3")
            )}
          </td>

          <td>
            {formatNumber(currentRevenueRow.jan)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.feb)}
          </td>

          <td>
            {formatNumber(currentRevenueRow.mar)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(currentRevenueRow, "Q4")
            )}
          </td>

          <td>
            {formatNumber(
              calculateTotal(currentRevenueRow)
            )}
          </td>

        </tr>


        {/* =========================================
            NET ADD - PREVIOUS YEAR
        ========================================= */}

        <tr>

          <td>
            <strong>
              Net Add {previousFYLabel}
            </strong>
          </td>

          <td>
            {formatNumber(previousNetAddRow.apr)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.may)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.jun)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousNetAddRow, "Q1")
            )}
          </td>

          <td>
            {formatNumber(previousNetAddRow.jul)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.aug)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.sep)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousNetAddRow, "Q2")
            )}
          </td>

          <td>
            {formatNumber(previousNetAddRow.oct)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.nov)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.dec)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousNetAddRow, "Q3")
            )}
          </td>

          <td>
            {formatNumber(previousNetAddRow.jan)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.feb)}
          </td>

          <td>
            {formatNumber(previousNetAddRow.mar)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousNetAddRow, "Q4")
            )}
          </td>

          <td>
            {formatNumber(
              calculateTotal(previousNetAddRow)
            )}
          </td>

        </tr>


        {/* =========================================
            REVENUE - PREVIOUS YEAR
        ========================================= */}

        <tr>

          <td>
            <strong>
              Revenue {previousFYLabel}
            </strong>
          </td>

          <td>
            {formatNumber(previousRevenueRow.apr)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.may)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.jun)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousRevenueRow, "Q1")
            )}
          </td>

          <td>
            {formatNumber(previousRevenueRow.jul)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.aug)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.sep)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousRevenueRow, "Q2")
            )}
          </td>

          <td>
            {formatNumber(previousRevenueRow.oct)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.nov)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.dec)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousRevenueRow, "Q3")
            )}
          </td>

          <td>
            {formatNumber(previousRevenueRow.jan)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.feb)}
          </td>

          <td>
            {formatNumber(previousRevenueRow.mar)}
          </td>

          <td>
            {formatNumber(
              getQuarterValue(previousRevenueRow, "Q4")
            )}
          </td>

          <td>
            {formatNumber(
              calculateTotal(previousRevenueRow)
            )}
          </td>

        </tr>

      </tbody>

    </table>

  </div>

</div>

{/* ===== REVENUE & NET ADD YTD ========= */}

<div className="col-md-12 mb-4">
  <div className="card border" style={{borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.15)"}}>
    <div className="card-body py-3">

      <h5 className="mb-3">
        Revenue & Net Add (YTD)
      </h5>

      <div className="row align-items-center">

        {/* Current FY */}
        <div className="col-md-3">
          <div className="text-muted fs-12 fw-semibold mb-1">
            FY {currentFYLabel}
          </div>

          <div
            className="fw-bold"
            style={{
              fontSize: "20px",
              color: "#e85d04",
            }}
          >
            ₹{formatNumber(currentYTDRevenue)}
          </div>

          <div className="text-muted fs-12 mt-1">
            Net Add: ₹{formatNumber(currentYTDNetAdd)}
          </div>
        </div>

        {/* Previous FY */}
        <div className="col-md-3">
          <div className="text-muted fs-12 fw-semibold mb-1">
            FY {previousFYLabel}
          </div>

          <div
            className="fw-bold"
            style={{
              fontSize: "20px",
              color: "#555",
            }}
          >
            ₹{formatNumber(previousYTDRevenue)}
          </div>

          <div className="text-muted fs-12 mt-1">
            Net Add: ₹{formatNumber(previousYTDNetAdd)}
          </div>
        </div>

        {/* Revenue Growth */}
        <div className="col-md-3">
          <div className="text-muted fs-12 fw-semibold mb-1">
            Revenue Growth
          </div>

          <div
            className="fw-bold"
            style={{
              fontSize: "20px",
              color: revenueGrowth >= 0 ? "#198754" : "#dc3545",
            }}
          >
            {revenueGrowth >= 0 ? "▲" : "▼"}{" "}
            {Math.abs(revenueGrowth).toFixed(2)}%
          </div>

          <div className="text-muted fs-12 mt-1">
            vs FY {previousFYLabel}
          </div>
        </div>

        {/* Net Add Growth */}
        <div className="col-md-3">
          <div className="text-muted fs-12 fw-semibold mb-1">
            Net Add Growth
          </div>

          <div
            className="fw-bold"
            style={{
              fontSize: "20px",
              color: netAddGrowth >= 0 ? "#198754" : "#dc3545",
            }}
          >
            {netAddGrowth >= 0 ? "▲" : "▼"}{" "}
            {Math.abs(netAddGrowth).toFixed(2)}%
          </div>

          <div className="text-muted fs-12 mt-1">
            vs FY {previousFYLabel}
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

                  {/* =========  SECTOR + REGION ========= */}

                  <div className="col-md-6 mb-4">
                    <div className="card-title mt-3">Sector</div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap">
                        <thead className="table-dark">
                          <tr>
                            <th>Sector</th>
                            <th>Revenue</th>
                            <th>Target</th>
                            <th>%</th>
                          </tr>
                        </thead>

                        <tbody>
                          {sectorData.map((row) => {
                            const revenue = Number(row.revenue || 0);
                            const target = Number(row.target || 0);
                            const percentage = target > 0 ? (revenue / target) * 100 : 0;
                            return (
                              <tr key={row.id}>
                                <td>{row.entity_name}</td>
                                <td>{formatNumber(revenue)}</td>
                                <td>{formatNumber(target)}</td>
                                <td>{percentage.toFixed(1)}%</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="col-md-6 mb-4">
                    <div className="card-title mt-3">Region</div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap">
                        <thead className="table-dark">
                          <tr>
                            <th>Region</th>
                            <th>Achievement</th>
                          </tr>
                        </thead>
                        <tbody>
                          {regionData.map((row) => (
                            <tr key={row.id}>
                              <td>{row.entity_name}</td>
                              <td>{formatNumber(row.revenue)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ======== NEW BUSINESS DEVELOPMENT ========== */}
                  <div className="col-md-6 mb-4">
                    <div className="card-title mt-3">New Business Development</div>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <td>12 Months</td>
                            <td>{formatNumber(snapshot.new_business_12_months)}</td>
                          </tr>
                          <tr>
                            <td>24 Months</td>
                            <td>{formatNumber(snapshot.new_business_24_months)}</td>
                          </tr>
                          <tr>
                            <td>Total</td>
                            <td>{formatNumber(snapshot.new_business_total)}</td>
                          </tr>
                          <tr>
                            <td>vs Total Revenue (%)</td>
                            <td>{Number(snapshot.new_business_vs_revenue_pct || 0)}%</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ======== KEY METRICS ========= */}

                  <div className="col-md-6 mb-4">
                    <div className="card-title mt-3">Key Metrics</div>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <tbody>
                          <tr>
                            <td>Closures</td>
                            <td>{formatNumber(snapshot.closures)}</td>
                          </tr>
                          <tr>
                            <td>Active Roles</td>
                            <td>{formatNumber(snapshot.active_roles)}</td>
                          </tr>
                          <tr>
                            <td>ARPA</td>
                            <td>{formatNumber(snapshot.arpa)}</td>
                          </tr>
                          <tr>
                            <td>Average VOBT</td>
                            <td>{formatNumber(snapshot.average_vobt)}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ======== PARTNER PERFORMANCE ======= */}

                  <div className="col-md-6 mb-4">
                    <div className="card-title mt-3">Partner Performance</div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap">
                        <thead className="table-dark">
                          <tr>
                            <th>Partner</th>
                            <th>Net Add</th>
                            <th>Generated</th>
                          </tr>
                        </thead>
                        <tbody>
                          {partnerData.map((row) => (
                            <tr key={row.id}>
                              <td>{row.entity_name}</td>
                              <td>{formatNumber(row.net_add)}</td>
                              <td>{formatNumber(row.revenue_generated)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  {/* ======= OPERATING PARTNER PERFORMANCE =========== */}

                  <div className="col-md-6 mb-4">
                    <div className="card-title mt-3">Operating Partner Performance</div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap">
                        <thead className="table-dark">
                          <tr>
                            <th>Operating Partner</th>
                            <th>Net Add</th>
                            <th>Revenue</th>
                          </tr>
                        </thead>
                        <tbody>
                          {operatingPartnerData.map((row) => (
                            <tr key={row.id}>
                              <td>{row.entity_name}</td>
                              <td>{formatNumber(row.net_add)}</td>
                              <td>{formatNumber(row.revenue)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>  
            </div>
        </div>
        </>
    );
}

export default NewsletterMonthly;